import { Text } from '@mantine/core';
import 'animate.css';
import { Button } from '../../../Button/Button';
import Uploader from '../../../Uploader/Uploader';
import { Actions, Details, Header, ImageMobile, Wrapper } from './ScrollImage.style';

export type ScrollImageProps = {
  item: Json;
  isDisabled?: boolean;
  onOpen: (item: Json) => void;
};

export function ScrollImage(props: ScrollImageProps) {
  const { isDisabled, item } = props;
  const { generatorId, title, imageUrl, daysAgo, uploaderName, uploaderAvatar } = item;

  const style = {
    backgroundImage: `url(${imageUrl})`,
    opacity: imageUrl ? 1 : 0,
  };

  return (
    <Wrapper
      className='ScrollImage-wrapper animate__animated animate__fadeIn'
      data-testid='ScrollImage-wrapper'
      style={style}
    >
      <Details className='animate__animated animate__fadeInUp'>
        <Text fw={500} size='xl'>
          {generatorId}
        </Text>
        <Header
          component='h2'
          size='xl'
          fw={800}
          variant='gradient'
          // @ts-ignore
          gradient={{ from: 'yellow', to: 'pink', deg: 90 }}
        >
          {title}
        </Header>
        <Uploader
          large
          uploaderAvatar={uploaderAvatar}
          uploaderName={uploaderName}
          daysAgo={daysAgo}
        />
      </Details>
      <ImageMobile style={style} />

      <Actions className='animate__animated animate__bounceIn'>
        <Button
          onClick={() => props.onOpen(item)}
          gradient={{ from: 'yellow', to: 'pink', deg: 90 }}
          variant='gradient'
          size='lg'
          disabled={isDisabled}
        >
          Open in Playground
        </Button>
      </Actions>
    </Wrapper>
  );
}

export default ScrollImage;
